import { ReactElement } from "react";
import SubscriberIcon from "@components/ArticleMeta/SubscriberFlag/SubscriberIcon";
import { useUserInfo } from "@features/mySph/hooks/useUserInfo";
import { cn } from "@util/helpers";

export type SubscriberFlagProps = {
  className?: string;
  label?: string;
};

/**
 * SubscriberFlag
 * Description: The subscriber flag of the article
 * @param {SubscriberFlagProps} props
 * @returns {ReactElement}
 *
 */
const SubscriberFlag = ({
  className,
  label,
}: SubscriberFlagProps): ReactElement => {
  const { isSubscriber } = useUserInfo();

  if (!isSubscriber) return <></>;

  return (
    <div
      className={cn(
        "relative mt-1 flex items-center gap-x-1 font-poppins text-4xs uppercase leading-130 text-gray-750",
        className
      )}
      data-testid="subscriber-flag-component"
    >
      <SubscriberIcon />

      <span>{label || "subscriber exclusive"}</span>
    </div>
  );
};

export default SubscriberFlag;
